import React, { useState, useEffect } from "react";
import { Routes, Route, BrowserRouter as Router } from "react-router-dom";
import ScrollToTop from "./ScrollToTop";
import { ClinicProvider } from './context/ClinicContext'; 
import Account from "./components/account";
import Footer from "./components/footer/Footer";
import './App.css';
import ProtectedRoute from '../src/ProtectedRoute';
import { ToastContainer } from 'react-toastify';
import HeaderComponent from "../src/components/header/header.component";
import Home from "./views/Home.view";
import AboutUsPageComponent from "../src/components/home/aboutUs/aboutUsPage.component";
import RegistrationCompleteForm from './components/registration-multi-step-forms/RegistrationCompleteForm';
import RegistrationSuccess from './components/registration-multi-step-forms/registrationSuccess.component';
import ContactUs from "./components/contactUs/Contactus";
// import TimelineComponent from "./components/home/Timeline/Timeline.component";
import ProfileComponent from "./components/account/Profile/ProfileComponent";
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { SITE_KEY } from "./utils/Constants";
import Staff from "./views/Staff.view";
// import SchedulingComponent from "./components/Scheduling/SchedulingComponent";
import PatientView from "./components/Scheduling/views/PatientView";
// import BookingCalendarView from "./components/Scheduling/views/BookingCalendarView";
import BookingCalendarView from "./components/Scheduling/views/SchedulingCalendarView";
import BookingSummaryView from "./components/Scheduling/views/BookingSummaryView";
// import DoctorDashboardWrapper from "./components/Scheduling/views/DoctorDashboardWrapper"
import DoctorDashboard from "./components/Scheduling/views/DoctorDashboard";
import AdminDashboard from "./components/Scheduling/views/AdminView";
// import LandingPage from "./components/Dashbords/landingPage.component";
import PricingHeaderComponent from "./components/registration-multi-step-forms/PricingHeaderComponent";
import DoctorsPage from "./components/DoctorsPortal/DoctorsPage.component";
import DoctorDetailPage from "./components/DoctorsPortal/DoctorDetailPage.component";
import TestComponent from "./components/Scheduling/views/TestComponent";
import DoctorAvailabilityComponent from "./components/Scheduling/views/DoctorAvailabilityComponent";
import {mockDoctors} from "./components/DoctorsPortal/mockData"
// import PractitionersPage from "./components/DoctorsPortal/PractitionersPage.component";
import PractitionersDetails from "./components/DoctorsPortal/PractitionersDetails.component";
import OnboardingSuccess from "./components/Payments/onboardingSuccess.component";
import PatientAppointmentsView from "./components/Scheduling/views/PatientAppointmentsView";
// import AdminPractitionerPricing from "./components/Scheduling/views/AdminPractitionerPricingView";
import VideosPage from "./components/Videos/VideosPage";
import TestTerms from "./components/PdfViewer/TestTerms";
import { getClinicId , isWhiteLabelEnabled} from "./utils/config";
import WhiteLabelFooter from "./components/footer/WhiteLabelFooter";
import TermsPageMain from "./components/Terms/TermsPage";
import AdminSchedulingWrapper from "./components/AdminSchedulingToggleWrapper/AdminSchedulingWrapper";
// import PricingCalculator from "./components/ClinicPricing/PricingCalculator";
import ClinicChatView from "./components/ChatWindow/ClinicChatView"
import ViewIntakeForm from "./components/Scheduling/views/ViewIntakeForm";
// import PatientBookingTool from "./components/PatientScheduling/PatientBookingTool";
import PatientAvailabilityTool from "./components/NewPatientScheduling/components/PatientAvailabilityTool";
import PricingPublicCalculator from "./components/registration-multi-step-forms/PricingPublicCalculator";
import QuickPatientSignup from "./components/QuickPatientSignup/QuickPatientSignup";
import ReportsPage from "./components/Reports/ReportsPage";
import PatientTimeline from "./components/PatientTimeline/PatientTimeline";
import Configurations from "./components/Configurations/Configurations";

// Stripe
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import PaymentComponent from "./components/Payments/PaymentComponent";
import StripeOnboarding from "./components/Payments/StripeOnboarding";
import PatientIntakeForm from "./components/Scheduling/components/IntakeForm/PatientIntakeForm";
import ManagePaymentsSection from "./components/ManagePaymentsSection/ManagePaymentsSection";
import ClinicSettings from "./components/ClinicSettings/ClinicSettings";
import { getClinicName, getStripePublicKey } from "./utils/config";

const stripePromise = loadStripe(getStripePublicKey());
const App = (props) => {

  const [type, setType] = useState(0);
  const [logged_in, setLogged_in] = useState(false);
  const [user, setUser] = useState({});
  // const [chargesEnabled, setChargesEnabled] = useState(null);

  const account = (type) => {
    sessionStorage.removeItem("propmpt_login");
    setType(type);
  };

  const success = (user, redirect) => {
    sessionStorage.removeItem("propmpt_login");
    setLogged_in(true);
    setType(0);
    // Ensure user object contains the role
    const updatedUser = { ...user, isSignedUp: true, role: user.role };
    setUser(updatedUser);

    localStorage.setItem("logged_in", true);
    localStorage.setItem("user", btoa(JSON.stringify(updatedUser)));

    if (redirect) {
      window.location = "/success";
    }
  };

  const logout = () => {
    localStorage.clear();
    sessionStorage.clear();
    setLogged_in(false);
    setUser({});
    sessionStorage.removeItem("propmpt_login");
  };

  useEffect(() => {
    if (localStorage.getItem("logged_in")) {
      setLogged_in(true);
      setUser(JSON.parse(atob(localStorage.getItem("user"))));
    }

    if (sessionStorage.getItem("propmpt_login")) {
      setType(1);
    }
    if (sessionStorage.getItem("propmpt_register")) {
      setType(2);
      sessionStorage.removeItem("propmpt_register");
    }
  }, []);

  useEffect(() => {
    const triggerLogin = sessionStorage.getItem("triggerLogin");

    if (triggerLogin === "true") {
        setType(1);  //Show login popup for white-labeled users
    } 

    sessionStorage.removeItem("triggerLogin"); // Clean up flag after redirection
}, []);



  useEffect(() => {
    const clinicName = getClinicName();
    document.title = clinicName
      ? `PlusLife | ${clinicName}`
      : 'PlusLife';
  }, []);

  return (
    <>
      <GoogleReCaptchaProvider reCaptchaKey={SITE_KEY}>
        <ToastContainer 
          position="top-right" 
          autoClose={3000} 
          hideProgressBar={false} 
          closeOnClick 
          pauseOnHover 
          draggable 
          theme="light" 
        />
          <ClinicProvider>
            <Router>
              <ScrollToTop />
                <div>
                  <div className="theme-layout" id="scrollup">
                    <HeaderComponent
                      account={account}
                      logout={logout}
                      logged_in={logged_in}
                      user={user}
                    />
                  
                    <Routes>
                      <Route
                        exact
                        path="/"
                        element={
                        
                          <Home
                            {...props}
                            logged_in={logged_in}
                            account={account}
                            user={user}
                          />}
                      />
                      {/* <Route
                        exact
                        path="/dashboard"
                        element={
                          <ProtectedRoute logged_in={logged_in}>
                            <LandingPage
                              {...props}
                              logged_in={logged_in}
                              user={user}
                              account={account}
                            />
                           </ProtectedRoute>
                          }
                      /> */}
                      <Route
                        exact
                        path="/configure-availability"
                        element={
                          <ProtectedRoute logged_in={logged_in}>
                            <DoctorAvailabilityComponent
                              {...props}
                              logged_in={logged_in}
                              user={user}
                            />
                           </ProtectedRoute>
                          }
                      />
                      <Route
                        exact
                        path="/manage-staff"
                        element={
                          <ProtectedRoute logged_in={logged_in}>
                            <Staff
                              {...props}
                              logged_in={logged_in}
                              account={account}
                              user={user}
                            />
                          </ProtectedRoute>
                            }
                      />
                      <Route
                        exact
                        path="/doctors"
                        element={
                          <ProtectedRoute logged_in={logged_in}>
                            <DoctorsPage
                                {...props}
                                logged_in={logged_in}
                                account={account}
                                user={user}
                              />
                          </ProtectedRoute>
                            }
                      />
                      {/* <Route
                        exact
                        path="/practitioners"
                        element={
                          <ProtectedRoute logged_in={logged_in}>
                            <PractitionersPage
                              {...props}
                              logged_in={logged_in}
                              user={user}
                            />
                          </ProtectedRoute>
                          }
                      /> */}
                      <Route
                        exact
                        path="/practitioners/:id"
                        element={
                          <ProtectedRoute logged_in={logged_in}>
                            <PractitionersDetails
                              {...props}
                              logged_in={logged_in}
                              user={user}
                            />
                          </ProtectedRoute>
                          }
                      />
                      <Route
                        exact
                        path="/doctor/:id"
                        element={
                          <ProtectedRoute logged_in={logged_in}>
                            <DoctorDetailPage
                              {...props}
                              logged_in={logged_in}
                              account={account}
                              user={user}
                              doctors={mockDoctors}
                            />
                          </ProtectedRoute>
                          }
                      />
                      <Route
                        exact
                        path="/about"
                        element={
                          <AboutUsPageComponent
                            {...props}
                            logged_in={logged_in}
                            account={account}
                            user={user}
                          />}
                      />
                      <Route
                        exact
                        path="/profile"
                        element={
                          <ProtectedRoute logged_in={logged_in}>
                            <ProfileComponent user={user} />
                          </ProtectedRoute>
                          }
                      />
                      <Route
                        exact
                        path="/register"
                        element={
                          <RegistrationCompleteForm
                            account={account}
                            logout={logout}
                            logged_in={logged_in}
                            user={user}
                          />}
                      />
                      <Route
                        path="/registration-success"
                        element={<RegistrationSuccess success={success} user={user} />}
                      />
                      <Route
                        exact
                        path="/contact"
                        element={
                          <ContactUs
                            {...props}
                            logged_in={logged_in}
                            account={account}
                            user={user}
                          />}
                      />
                      <Route
                        exact
                        path="/pricing"
                        element={
                          <PricingHeaderComponent
                            {...props}
                            logged_in={logged_in}
                            account={account}
                            user={user}
                          />}
                      />
                  
                      {/* Below routes are only for testing purposes in local host to access directly , will be removed later */}
                      <Route 
                        path="/scheduling/:patient_id" 
                        element={
                          <ProtectedRoute logged_in={logged_in}>
                              <PatientView
                                {...props}
                                logged_in={logged_in}
                                user={user}
                              />
                          </ProtectedRoute>
                            }
                          />
                      <Route 
                        path="/book-appointment" 
                        element={
                          <ProtectedRoute logged_in={logged_in}>
                            <BookingCalendarView
                              logged_in={logged_in}
                              user={user}
                            />
                          </ProtectedRoute>
                        } 
                      />
                      <Route 
                        path="/booking-summary" 
                        element={
                          <ProtectedRoute logged_in={logged_in}>
                            <BookingSummaryView 
                            logged_in={logged_in}
                              user={user}
                            />
                          </ProtectedRoute>
                        } 
                      />
                      <Route path="/practitioner-dashboard/:doctor_id" 
                        element={
                          <ProtectedRoute logged_in={logged_in}>
                            <DoctorDashboard
                            user = {user} 
                            logged_in={logged_in}
                            />
                          </ProtectedRoute>
                        } 
                        /> 

                      <Route 
                        path="/admin-dashboard/:role/:clinic_id" 
                        element={
                          <ProtectedRoute logged_in={logged_in}>
                            <AdminDashboard 
                              {...props}
                              logged_in={logged_in}
                              user={{
                                ...user, 
                                clinic_id: getClinicId(user)
                              }}
                              logout={logout}
                            />
                          </ProtectedRoute>
                        } 
                      />


                      <Route
                        path="/patient-appointments" 
                        element={
                          <ProtectedRoute logged_in={logged_in}>
                            <PatientAppointmentsView 
                            user={user} />
                          </ProtectedRoute>
                        } 
                      />

                      {/* The Below route is only meant for testing standAlone components , should be removed in the final stage */}
                      <Route path="/testing" element={<TestComponent/>} />
                      <Route
                        path="/test-payment"
                        element={
                            <Elements stripe={stripePromise}>
                                <PaymentComponent clinicPatientId={1} amount={100} />
                            </Elements>
                        }
                    />
                    <Route path="/stripe-onboarding" element={<StripeOnboarding user={user} />} />
                    {/* <Route path="/stripe-onboarding/success" element={<StripeOnboarding user={user} />} /> */}
                   
                    <Route path="/stripe-onboarding/success" element={< OnboardingSuccess />} />
                    {/* <Route path="/admin-pricing" element={<AdminPractitionerPricing user={user} />} /> */}
                    <Route path="/videos" element={<VideosPage />} />
                    <Route path="/test-terms" element={<TestTerms />} />
                    <Route path="/terms" element={<TermsPageMain />} />

                    <Route 
                      path="/admin-scheduling" 
                      element={
                        <ProtectedRoute logged_in={logged_in}>
                          <AdminSchedulingWrapper user={user} />
                        </ProtectedRoute>
                      } 
                    />


                    {/* <Route 
                      path="/clinic-pricing" 
                      element={
                          <PricingCalculator />
                      } 
                    /> */}
                    <Route 
                      path="/clinic-pricing" 
                      element={
                          <PricingPublicCalculator />
                      } 
                    />
                    <Route 
                      path="/communication-console" 
                      element={
                        <ProtectedRoute logged_in={logged_in}>
                          <ClinicChatView />
                        </ProtectedRoute>
                      } 
                    />

                    <Route 
                      path="/health-history" 
                      element={
                        <ProtectedRoute logged_in={logged_in}>
                          <PatientIntakeForm user={user} />
                        </ProtectedRoute>
                      } 
                    />

                    <Route 
                      path="/view-intake/:patientId/:doctorId" 
                      element={
                        <ProtectedRoute logged_in={logged_in}>
                        <ViewIntakeForm user={user} />
                        </ProtectedRoute>
                      } 
                    />

                    {/* <Route 
                      path="/patient-scheduling" 
                      element={
                        <ProtectedRoute logged_in={logged_in}>
                        <PatientBookingTool user={user} />
                        </ProtectedRoute>
                         
                      }
                      /> */}

                      <Route 
                        path="/customer-scheduling" 
                        element={
                          <ProtectedRoute logged_in={logged_in}>
                            <PatientAvailabilityTool user={user} />
                          </ProtectedRoute>
                        }
                      />

                      <Route 
                        path="/manage-cards" 
                        element={
                          <ProtectedRoute logged_in={logged_in}>
                            <Elements stripe={stripePromise}>
                              <ManagePaymentsSection user={user} />
                            </Elements>
                          </ProtectedRoute>
                        }
                      />
                      <Route 
                        path="/clinic-settings"
                        element={
                          <ProtectedRoute logged_in={logged_in}>
                          <ClinicSettings user={user} />
                          </ProtectedRoute>
                      }
                      />
                      <Route 
                        path="/quick-patient-signup" 
                        element={
                          <ProtectedRoute logged_in={logged_in}>
                            <QuickPatientSignup user={user} />
                          </ProtectedRoute>
                        }
                      />
                      <Route 
                        path="/reports" 
                        element={
                          <ProtectedRoute logged_in={logged_in}>
                            <ReportsPage user={user}/>
                          </ProtectedRoute>
                        }
                      />
                      <Route path="/patient-timeline/:patientId" element={<PatientTimeline user={user} />} />
                      <Route path="/configurations/*" element={<Configurations user={user} />} />

                    </Routes>

                    {isWhiteLabelEnabled() ? <WhiteLabelFooter /> : <Footer />}
                  </div>
                  {type ? <Account type={type} user={user} logged_in={logged_in} account={account} success={success} /> : ''}
                </div>
            </Router>
          </ClinicProvider>
      </GoogleReCaptchaProvider>
    </>
  );
};

export default App;
